import {
  compose,
  withAuthorized,
  withSuperAdminLayout,
  withHelmet
} from '../../core';
import { SuperAdminUserEditContainer } from '../../features/super-admin-users/SuperAdminUserEdit';

export const SuperAdminUserEdit = compose(
  withAuthorized,
  withSuperAdminLayout,
  withHelmet({
    title: 'Splashworks: Super Admin Users'
  })
)(SuperAdminUserEditContainer);
